import { IonicButton } from 'ionic-ui';
import React, { memo } from 'react';
import EmptyPage from './EmptyPage';

type Props = {
  retry?: () => void;
  message?: string;
  className?: string;
  buttonLabel?: string;
};

const ErrorBanner = memo(function ({
  retry,
  message,
  buttonLabel = 'Try Again',
  className = '',
}: Props) {
  return (
    <EmptyPage
      message={message || 'Something went wrong'}
      className={className}
    >
      {retry && (
        <IonicButton
          onClick={retry}
          variant="ghost"
          className="high-emphasis-text w-fit mx-auto capitalize"
        >
          {buttonLabel}
        </IonicButton>
      )}
    </EmptyPage>
  );
});

export default ErrorBanner;
